<div class="container-fluid row_banner-ai pb-5">
  <app-header></app-header>
  <!-- Edditor  -->
  <div class="container">
    <div
      class="row text-center justify-content-center"
      style="align-content: center"
    >
      <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
        <h1 class="w-100 fnt-w600-40" style="margin-top: 40px">
          AI Text Detector
        </h1>
        <span class="w-100 d-inline-block main_text mt-40"
          >Uncover the instances of AI in any writing project with our AI
          detector.
        </span>
      </div>
    </div>
    <div class="custom-card">
      <p
        class="text-left success-msg"
        *ngIf="got_recpatcha"
        [ngStyle]="{
          color: color,
          'background-color': '#f8d7da',
          padding: '2px'
        }"
      >
        <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
        {{ recaptcha_message }}
      </p>
      <div class="row row-1">
        <div class="col-lg-1 col-md-12 col-12 icon-bar-word mt45">
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <div class="icon-bar">
            <div
              class="icon-bar-img"
              id="uploadFileS"
              value="Browse"
              onclick="document.getElementById('upload').click();"
            >
              <app-icons-free-tools [name]="'pcIcon'" />
              <input
                id="upload"
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
            <div class="icon-bar-img" (click)="openDropboxChooser()">
              <app-icons-free-tools [name]="'dropboxIcon'" />
            </div>
            <div class="icon-bar-img" (click)="gDriveUpload()">
              <app-icons-free-tools [name]="'googleIcon'" />
            </div>
          </div>
          
         <div class="words-char" style="        order: 4;">
      <div class="word-count">
        <p class="word-limit">
          Words Limit: {{ char_count === 0 ? 0 : word_count }}/1000
        </p>
      </div>
      </div>
          </div>




        </div>
        <div class="col-lg-11 col-md-12 col-12 top-bar">
          <div class="row">
            <div class="mobile-editor">
            <div
              class=" col-lg-8 col-md-12 col-sm-12 upload-section-mobile"
              style="overflow-y: auto; overflow-x: hidden"
            >
              <div
                class="upload-section"
                #editor
                id=""
                style="overflow-y: auto; overflow-x: hidden"
                style="word-break: break-all !important; padding-right: 10px"
                ngDefaultControl
                (click)="onclickeditor($event)"
                [(ngModel)]="text"
                contenteditable="true"
                id="editor"
                (keyup)="getContent($event, text)"
                spellcheck="false"
                data-gramm="false"
              ></div>
              <div *ngIf="showParagraph" class="editSectionDiv">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <h3 class="editor-heading">{{ content.header }}</h3>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="word_count !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="deleteText()"
                  class="icon-del"
                />
              </span>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 result-mobile desktop"  
           >
              <div
                class="result-section"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
                [ngClass]="{ 'response-received': gotresponse }"
              >
                <div class="mobile-Content-Score">
                  <h3
                  style="
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 18px;
                    text-align: center;
                  "
                  class="mb-md-5 content-score "
                >
                  Human Content Score
                </h3>
                <circle-progress
                  [percent]="human_score"
                  [title]="human_score + '%'"
                  [titleFontSize]="'16'"
                  [titleFontWeight]="'600'"
                  [radius]="circleProgressRadius"
                  outerStrokeLinecap="round"
                  [backgroundColor]="'#ffffff'"
                  innerStrokeWidth="10"
                  [space]="-10"
                  [outerStrokeWidth]="10"
                  outerStrokeColor="#08BA9C"
                  [showInnerStroke]="true"
                  [animationDuration]="300"
                  [animation]="false"
                  [showBackground]="false"
                  [clockwise]="true"
                  [showZeroOuterStroke]="true"
                  [animationDuration]="0"
                  innerStrokeColor="#E3E3F0"
                  [showSubtitle]="false"
                  [showTitle]="true"
                  [showUnits]="false"
                >
                </circle-progress>
                </div>
                <div style="display: inline-block" class="mt-md-4">
                  <div
                    class="div-1"
                    [ngClass]="{ 'response-received': gotresponse }"
                  >
                    <p class="resscore">Human Written Content: {{ human_score }}%</p>
                  </div>
                  <div
                    class="div-1"
                    [ngClass]="{ 'response-received': gotresponse }"
                  >
                    <p class="resscore">AI Written Content: {{ ai_score }}%</p>
                  </div>
                </div>
              </div>
            </div>
              <div class="col-lg-4 col-md-12 col-sm-12 result-mobile mobile"  
                 *ngIf="gotresponse"
           >
         
              <div
                class="result-section-mobile"
               
                [ngClass]="{ 'response-received': gotresponse }"
              >
                <div class="mobile-Content-Score">
                  <h3
                  style="
                    font-size: 18px;
                    font-weight: 600;
                    line-height: 18px;
                    text-align: center;
                  "
                  class=" content-score "
                >
                  Human <br> Content Score
                </h3>
                <circle-progress
                  [percent]="human_score"
                  [title]="human_score + '%'"
                  [titleFontSize]="'16'"
                  [titleFontWeight]="'600'"
                  [radius]="circleProgressRadius"
                  outerStrokeLinecap="round"
                  [backgroundColor]="'#ffffff'"
                  innerStrokeWidth="4"
                  [space]="-4"
                  [outerStrokeWidth]="4"
                  outerStrokeColor="#08BA9C"
                  [showInnerStroke]="true"
                  [animationDuration]="300"
                  [animation]="false"
                  [showBackground]="false"
                  [clockwise]="true"
                  [showZeroOuterStroke]="true"
                  [animationDuration]="0"
                  innerStrokeColor="#E3E3F0"
                  [showSubtitle]="false"
                  [showTitle]="true"
                  [showUnits]="false"
                >
                </circle-progress>
                </div>
                <div  class=" div-ps">
                  <div
                    class="div-p px-1"
                    [ngClass]="{ 'response-received': gotresponse }"
                  >
                    <p class="resscore">Human Written Content: {{ human_score }}%</p>
                  </div>
                  <div
                    class="div-p px-1"
                    [ngClass]="{ 'response-received': gotresponse }"
                  >
                    <p class="resscore">AI Written Content: {{ ai_score }}%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="progress-loader-div">
            <div class="progress-loader" *ngIf="loaderAlert"></div>
          </div>
      
          <div class="edit-buttons">
            <div class="word-count">
              <p class="word-limit">
                Words Limit: {{ char_count === 0 ? 0 : word_count }}/1000
              </p>
            </div>
            <div class=" right-buttons">
              <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                <div class="captcha-modal">
                  <div
                    id="recaptcha-container"
                    class="recaptcha-container"
                    data-size="compact"
                    data-theme="light"
                  ></div>
                </div>
              </div>
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                aria-label="Try Again"
                *ngIf="gotresponse"
                (click)="handleButtonClick()"
              >
                <img id="retry" /> <span class="tooltiptext">Retry</span>
              </button>

              <button
                class="btn btn-dark btn-summarize"
                (click)="handleButtonClick()"
              >
             
                Check AI Content
              </button>
            </div>
          </div>
     

          <!-- code for validation  -->
          <div
            *ngIf="error"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="error"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center" style="margin-top: 9%">
              <app-icons-free-tools name="errorIcon" />

              <div style="width: 440px; height: 64px; margin-left: 16px">
                <p
                  class="error mt-4 content-div-p"
                  style="
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 33.89px;
                  "
                >
                  {{ errorAlerts }}
                </p>
              </div>

              <button class="mt-4 butn-alert" (click)="closeErrorDiv()">
                Ok
              </button>
            </div>
          </div>

          <div
            *ngIf="success"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="success"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center" style="margin-top: 9%">
            
              <app-icons-free-tools name="successIcon" />
              <p
                *ngIf="success"
                class="error mt-4 content-div-p"
                style="font-size: 24px; font-weight: 500; line-height: 33.89px"
              >
                {{ successAlert }}
              </p>

            </div>
          </div>
          <!-- code for validation  -->
        </div>
      </div>
    </div>

    <div class="mobile-edit-buttons">
      <!-- <div class="word-count">
        <p class="word-limit">
          Words Limit: {{ char_count === 0 ? 0 : word_count }}/1000
        </p>
      </div> -->
      <div class=" right-buttons">
        <div *ngIf="captchaVisible" class="captcha-modal-overlay">
          <div class="captcha-modal">
            <div
              id="recaptcha-container"
              class="recaptcha-container"
              data-size="compact"
              data-theme="light"
            ></div>
          </div>
        </div>
        <button
          id="adv-tech"
          class="download-img tooltipss butn"
          aria-label="Try Again"
          *ngIf="gotresponse"
          (click)="handleButtonClick()"
        >
          <img id="retry" /> <span class="tooltiptext">Retry</span>
        </button>

        <button
          class="btn btn-dark btn-summarize"
          (click)="handleButtonClick()"
        >
       
          Check AI Content
        </button>
      </div>
    </div>
  </div>
  
</div>
<div
    class="container justify-content-center"
    id="how-to-use-bg"
    style="margin-top: 65px; justify-content: center; text-align: center"
  >
    <h2 style="font-weight: 700">How to Detect AI Text?</h2>
    <p class="fnt-18-400">
      Ensure the authenticity of written work swiftly by following the simple
      steps shared below.
    </p>
    <div class="row justify-content-center">
      <div class="tabs">
        <div class="row">
          <img
            src="../../assets/images/ai-text-detector/Access Our Tool.svg"
            id="home-tabs-img"
            alt="home-tabs-img"
          />
        </div>
        <div class="row" style="float: left; text-align: left">
          <h3 class="fnt-w500-20-18 mt-3">Access Our Tool</h3>
        </div>
        <div class="row" style="float: left; text-align: left">
          <p class="fnt-w500-16">
            Land on the advanced AI tools offered on this platform. You won't be
            asked to create an account to access this AI content detector.
          </p>
        </div>
      </div>
      <div class="tabs">
        <div class="row">
          <img
            src="../../assets/images/ai-text-detector/Upload Content.svg"
            id="home-tabs-img"
            alt="home-tabs-img1"
          />
        </div>
        <div class="row" style="float: left; text-align: left">
          <h3 class="fnt-w500-20-18 mt-3">Upload Content</h3>
        </div>
        <div class="row" style="float: left; text-align: left">
          <p class="fnt-w500-16">
            Next, submit the text you want to check for AI content. You can
            upload the text file directly or paste the content in the text
            field.
          </p>
        </div>
      </div>
      <div class="tabs">
        <div class="row">
          <img
            src="../../assets/images/ai-text-detector/Click on the Check AI Content.svg"
            id="home-tabs-img"
            alt="home-tabs-img2"
          />
        </div>
        <div class="row" style="float: left; text-align: left">
          <h3 class="fnt-w500-20-18 mt-3">
            Click on the "Check AI Content" Button
          </h3>
        </div>
        <div class="row" style="float: left; text-align: left">
          <p class="fnt-w500-16">
            After uploading the text file, click on the given button to start
            the AI content examining process.
          </p>
        </div>
      </div>
      <div class="tabs">
        <div class="row">
          <img
            src="../../assets/images/ai-text-detector/AI Detection Completed.svg"
            id="home-tabs-img"
            alt="home-tabs-img3"
          />
        </div>
        <div class="row" style="float: left; text-align: left">
          <h3 class="fnt-w500-20-18 mt-3">AI Detection Completed</h3>
        </div>
        <div class="row" style="float: left; text-align: left">
          <p class="fnt-w500-16">
            The AI detector will scan your input text and examine it thoroughly
            to identify if it's generated by AI or human-written. Any instance
            of AI in the text will be highlighted, and you will get a detailed
            results report in a few seconds.
          </p>
        </div>
      </div>
    </div>
  </div>

<div class="container mb-4">
  <app-premium />
</div>
<div class="container justify-content-center">
  <div class="container" id="para-key-main">
    <div class="row">
      <h2 class="fnt-w600-40 text-center">
        AI-Generated Content Detection Model
      </h2>
      <p style="text-align: center; margin-top: 20px" class="fnt-18-400">
        Our Al text detector performs the Al detection process in multiple
        phases.A brief glimpse of how this Al tool works is shared below.
      </p>
      <div class="col-12">
      <div class="tabs_wrapper mt-3">
     
          <div class="btns-divs">
            <button
              class="mb-3 mybtn p-2"
              [ngClass]="{ active: selectedTab === 'tab1' }"
              (click)="selectTab('tab1')"
              id="adv-tech"
            >
              <img
                id="data-collection"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="plag-img"
              />
              <h3 class="section-3-plag-tabs-p" style="margin-top: 5px">
                Data Collection
              </h3>
            </button>
            <button
              class="mb-3 mybtn p-2"
              [ngClass]="{ active: selectedTab === 'tab2' }"
              (click)="selectTab('tab2')"
              id="adv-tech"
            >
              <img
                id="pattern-recognition"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="plag-img"
              />
              <h3 class="section-3-plag-tabs-p">Pattern Recognition</h3>
            </button>
            <button
              class="mb-3 mybtn p-2"
              [ngClass]="{ active: selectedTab === 'tab3' }"
              (click)="selectTab('tab3')"
              id="adv-tech"
            >
              <img
                id="insighful-gidance"
                class="section-3-plag-tabs-img me-3 ms-2"
                alt="plag-img"
              />
              <h3 class="section-3-plag-tabs-p" style="margin-top: 0px">
                Insightful Guidance
              </h3>
            </button>
          </div>
       
          <div
            class="tab_container"
            style="background-color: #f7f7fa; border-radius: 8px"
          >
            <div *ngIf="selectedTab === 'tab1'" class="tab_content">
              <p id="contentss">
                The first step of AI detection is data collection. In this
                phase, the AI content detector conducts an in-depth analysis of
                your uploaded text with directory GPT models used to create AI
                content.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab2'" class="tab_content">
              <p id="contentss">
                In this phase, our AI identifier examines every feature of
                content, including sentence structure, vocabulary, and layout of
                the content. The key purpose of this phase is to ensure no small
                chunk of AI-generated phrases evades its harsh detection.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab3'" class="tab_content">
              <p id="contentss">
                In the last phase, the AI text detector uses actionable insights
                to verify if the submitted input data is original or
                AI-generated content. The tool represents the results in
                percentages to help you easily understand the portion of AI text
                in your article.
              </p>
            </div>
          </div>
      
      </div>
      </div>
    </div>
  </div>
  <div
    class="container"
    style="margin-top: 50px; box-sizing: border-box; text-align: left"
    id="para-key-phone"
  >
    <h2
      style="
        text-align: center;
        font-size: 30px;
        font-weight: 700;
        line-height: 37.8px;
        text-align: center;
      "
    >
      AI-Generated Content Detection Model
    </h2>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        Our Al text detector performs the Al detection process in multiple
        phases.A brief glimpse of how this Al tool works is shared below.
      </p>
    </div>
    <div
      class="v-pills-tab-list row"
      id="v-pills-tab-list"
      style="width: -webkit-fill-available"
    >
      <div class="" id="row_faqs">
        <div
          class="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-first-tab"
            aria-controls="q122"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q122"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
              >
                Data Collection</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q122"
              class="collapse"
              id="q122"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                The first step of AI detection is data collection. In this
                phase, the AI content detector conducts an in-depth analysis of
                your uploaded text with directory GPT models used to create AI
                content.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q64"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Pattern Recognition</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q122"
              class="collapse"
              id="q64"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                In this phase, our AI identifier examines every feature of
                content, including sentence structure, vocabulary, and layout of
                the content. The key purpose of this phase is to ensure no small
                chunk of AI-generated phrases evades its harsh detection.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
          <a
            class="nav-link nav-pills"
            style="margin: 8px 0; padding: 10px 14px; background: #fff"
            class="card active"
            id="v-pills-2nd-tab"
            aria-controls="q12"
            aria-expanded="false"
            class="mb-0 collapsed"
            data-toggle="collapse"
            href="#q74"
          >
            <h5>
              <span
                class="btn active"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne_One"
                aria-expanded="true"
                aria-controls="collapseOne_One"
                class="card-header headingsize"
                >Insightful Guidance</span
              >
              <i class="fas fa-chevron-down float-right down"></i>
            </h5>
            <div
              aria-labelledby="q12"
              class="collapse"
              id="q74"
              role="tabpanel"
              data-parent="#v-pills-tab-list"
            >
              <div class="card-body">
                In the last phase, the AI text detector uses actionable insights
                to verify if the submitted input data is original or
                AI-generated content. The tool represents the results in
                percentages to help you easily understand the portion of AI text
                in your article.
              </div>
            </div>
          </a>
          <hr style="margin-top: 0px; margin-bottom: 0px" />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid my-5" style="background: #ecf6f5">
  <div class="container">
    <div
      class="row justify-content-center"
      style="display: flex; align-items: center; padding: 30px 0px"
    >
      <div class="col-md-7 left-section">
        <h2 class="freeGrammarFont" id="align-center">
          Introduction of Our AI Content Detector
        </h2>
        <p class="freeGrammarFont-p mt-3" id="align-center">
          Artificial intelligence has undeniably changed the patterns of
          performing academic tasks. The availability of AI tools has posed a
          serious threat to maintaining academic integrity. Mainly, the advent
          of AI tools like ChatGPT has made it simpler for students to create
          unique content without any manual effort. This causes serious concerns
          for teachers and educational institutes as students start relying on
          these utilities instead of putting their own efforts into completing
          the given assignment. However, our AI detector offers a helping hand
          in detecting AI in their submitted academic assignments. This support
          enables them to determine whether the content is generated through
          ChatGPT or crafted by the students. No need to share any personal
          information! Yes! Our AI content detector doesn't ask you to sign up
          or follow any such intricacies. Simply connect your device to the
          internet, and you are all set to get assistance from this free AI
          detector.
        </p>
      </div>
      <div class="col-md-5 right-section">
        <img
          class="how-to-img"
          src="/../../assets/images/ai-text-detector/Introduction of Our AI Content Detector.svg"
          alt="text-ig"
        />
      </div>
    </div>
  </div>
</div>
<div
  class="container justify-content-center"
  id="how-to-use-bg "
  style="margin-top: 100px"
>
  <div class="row mt-5" style="box-sizing: border-box">
    <div class="col-md-12">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          font-weight: 700;
          line-height: 34px;
          text-align: center;
        "
        class="mbl-screen"
      >
        Benefits of Using This AI Checker
      </h2>
    </div>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
      "
    >
      <p>
        Our AI detector makes the detection of AI-generated content a no-uphill
        task for everyone. Below are some primary features of this <br />
        web-based AI-checking tool.
      </p>
    </div>
  </div>
</div>
<div
  class="container text-center justify-content-center section-6-para"
  style="margin-top: 30px"
  id="plag-Consequences-content"
>
  <div class="row justify-content-center">
    <div class="col-md-5 para-section-6-col">
      <div class="row mt-4">
        <div class="">
          <img
            src="../../assets/images/ai-text-detector/Reliable Results.svg"
            alt="100%-Reliable-Results"
            style="float: left"
          />
        </div>
        <div>
          <h3 class="fnt-w500-20 mt-4" style="align-items: start; float: left">
            100% Reliable Results
          </h3>
        </div>
      </div>
      <div class="row">
        <p id="" class="fnt-w500-16 para-section-6-p">
          Our web-based AI tool incorporates the most advanced technology to
          analyze your submitted content and gives you the quickest results. The
          output generated by this free AI tool will be flawless and can be
          cross-checked through any other online detector. You can share the
          results of this AI content checker with full confidence as evidence.
        </p>
      </div>
    </div>
    <div class="col-md-5 para-section-6-col">
      <div class="row mt-4">
        <div class="">
          <img
            src="../../assets/images/ai-text-detector/Uses Latest Technologies.svg"
            alt="Quick-img "
            style="float: left"
          />
        </div>
        <div class="">
          <h3 class="fnt-w500-20 mt-4" style="align-items: start; float: left">
            Uses Latest Technologies
          </h3>
        </div>
      </div>
      <div class="row">
        <p id="" class="fnt-w500-16 para-section-6-p">
          Our professional team strives hard to add new features to this AI
          detector to make it the best for detecting text generated from any AI
          tool. This web-based utility uses AI-powered technology to identify
          whether the text is human-written or created with AI tools.
        </p>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-5 para-section-6-col">
      <div class="row mt-4">
        <div>
          <img
            src="../../assets/images/ai-text-detector/Uninterrupted Customer Support.svg"
            alt="Improves-img"
            style="float: left"
          />
        </div>
        <div>
          <h3 class="fnt-w500-20 mt-4" style="align-items: start; float: left">
            Uninterrupted Customer Support
          </h3>
        </div>
      </div>
      <div class="row">
        <p id="" class="fnt-w500-16 para-section-6-p">
          Offering our valued customers, the utmost ease is our responsibility.
          Therefore, we are offering 24/7 customer support to our users. If you
          face any ambiguity or are stuck at any point while using this AI
          detector, simply contact us through email. Our team will surely get
          back to you within no time.
        </p>
      </div>
    </div>
    <div class="col-md-5 para-section-6-col">
      <div class="row mt-4">
        <div>
          <img
            src="../../assets/images/ai-text-detector/Secure to Use.svg"
            alt="Extract-img"
            style="float: left"
          />
        </div>
        <div>
          <h3 class="fnt-w500-20 mt-4" style="align-items: start; float: left">
            Secure to Use
          </h3>
        </div>
      </div>
      <div class="row">
        <p id="" class="fnt-w500-16 para-section-6-p">
          Maintaining the secrecy of the uploaded data is important to us. Our
          online AI tool has the ability to counter any unauthorized attempt to
          access users' uploaded data. Besides, the algorithms working the
          backend secure your data from hackers. We also guarantee you that the
          information you post on this AI checker will be erased.
        </p>
      </div>
    </div>
  </div>
</div>
<div
  class="container justify-content-center"
  id="use-guide-section-phone"
  style="margin-top: 100px"
>
  <div
    class="v-pills-tab-list row"
    id="use-guide-tab-list"
    style="width: -webkit-fill-available"
  >
    <div id="faqs-row">
      <div
        class="nav flex-column nav-pills"
        id="use-guide-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          id="ai-tech-tab"
          aria-controls="ai-tech-collapse"
          aria-expanded="false"
          data-toggle="collapse"
          href="#ai-tech-collapse"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#ai-tech-collapse"
              aria-expanded="true"
              aria-controls="ai-tech-collapse"
              class="card-header headingsize"
              >100% Reliable Results</span
            >
            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            id="ai-tech-collapse"
            class="collapse"
            role="tabpanel"
            data-parent="#use-guide-tab-list"
          >
            <div class="card-body">
              Our web-based AI tool incorporates the most advanced technology to
              analyze your submitted content and gives you the quickest results.
              The output generated by this free AI tool will be flawless and can
              be cross-checked through any other online detector. You can share
              the results of this AI content checker with full confidence as
              evidence.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          id="fast-free-tab"
          aria-controls="fast-free-collapse"
          aria-expanded="false"
          data-toggle="collapse"
          href="#fast-free-collapse"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#fast-free-collapse"
              aria-expanded="true"
              aria-controls="fast-free-collapse"
              class="card-header headingsize"
              >Uses Latest Technologies</span
            >
            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            id="fast-free-collapse"
            class="collapse"
            role="tabpanel"
            data-parent="#use-guide-tab-list"
          >
            <div class="card-body">
              Our professional team strives hard to add new features to this AI
              detector to make it the best for detecting text generated from any
              AI tool. This web-based utility uses AI-powered technology to
              identify whether the text is human-written or created with AI
              tools.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          id="unique-text-tab"
          aria-controls="unique-text-collapse"
          aria-expanded="false"
          data-toggle="collapse"
          href="#unique-text-collapse"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#unique-text-collapse"
              aria-expanded="true"
              aria-controls="unique-text-collapse"
              class="card-header headingsize"
              >Uninterrupted Customer Support</span
            >
            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            id="unique-text-collapse"
            class="collapse"
            role="tabpanel"
            data-parent="#use-guide-tab-list"
          >
            <div class="card-body">
              Offering our valued customers, the utmost ease is our
              responsibility. Therefore, we are offering 24/7 customer support
              to our users. If you face any ambiguity or are stuck at any point
              while using this AI detector, simply contact us through email. Our
              team will surely get back to you within no time.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          id="structured-content-tab"
          aria-controls="structured-content-collapse"
          aria-expanded="false"
          data-toggle="collapse"
          href="#structured-content-collapse"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#structured-content-collapse"
              aria-expanded="true"
              aria-controls="structured-content-collapse"
              class="card-header headingsize"
              >Secure to Use</span
            >
            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            id="structured-content-collapse"
            class="collapse"
            role="tabpanel"
            data-parent="#use-guide-tab-list"
          >
            <div class="card-body">
              Maintaining the secrecy of the uploaded data is important to us.
              Our online AI tool has the ability to counter any unauthorized
              attempt to access users' uploaded data. Besides, the algorithms
              working the backend secure your data from hackers. We also
              guarantee you that the information you post on this AI checker
              will be erased.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
      </div>
    </div>
  </div>
</div>
<!--Why We Developed This AI Text Detector? Section  -->
<div
  class="container justify-content-center"
  id="how-to-use-bg "
  style="margin-top: 100px"
>
  <div class="row mt-5" style="box-sizing: border-box">
    <div class="col-md-12">
      <h2
        style="
          text-align: center;
          font-size: 30px;
          font-weight: 700;
          line-height: 34px;
          text-align: center;
        "
      >
        Why We Developed This AI Text Detector?
      </h2>
    </div>
    <div
      class="col-md-12"
      style="
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 34px;
      "
    >
      <p class="mt-2">
        Maintaining professional honesty becomes a challenging chore in this
        AI-driven world. The instance of AI, if found in written work, may lead
        a writer student to face undesired consequences. With our top-notch AI
        detector, users can instantly detect ChatGPT or any other AI tool's
        generated content. This will help you verify the authenticity of your
        written work and aid you in presenting yourself as a credible source.
        Besides, it offers you a practical way to boost the appearance and
        quality of your written content, as people don't prefer reading AI
        content and move to human-looking text. Moreover, search engines also
        prefer authenticity. Using our online AI content detector, you can save
        yourself from facing any complications and present your targeted
        audience with completely unique and original content.
      </p>
    </div>
  </div>
</div>
<!-- Frequently asked questions Section -->
<div class="mt-5 qustion" id="home-faqs">
  <div class="justify-content-center" id="row_faqs" style="margin-bottom: 20px">
    <div class="faqs text-center">
      <h1 class="text-center">Frequently asked questions</h1>
      <p style="text-align: center" class="text mb-5 text">
        Learn more about platform by user questions
      </p>
    </div>
    <div class="v-pills-tab-list" id="v-pills-tab-list">
      <div id="row_faqs">
        <div
          class="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
          <div
            class="container container-grid"
            style="width: min(100% - 40px, 768px)"
          >
            <div
              class="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link nav-pills"
                style="
                  border: 1px solid #eaeaea;
                  padding: 10px 14px;
                  background-color: #f3f8fc;
                  border-radius: 10px;
                "
                [ngClass]="{ active: activeTab === 'q5' }"
                (click)="toggleTab('q5')"
                id="v-pills-first-tab"
                aria-controls="q5"
                aria-expanded="false"
                class="mb-0 collapsed"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header ms-3"
                    [class.closed]="activeTab !== 'q5'"
                  >
                    Do I Need to Purchase Any Premium Plan for AI Detection?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q5'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q5'"
                  />
                </div>

                <div
                  aria-labelledby="q5"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q5' }"
                  id="q5"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body carbody ms-3 me-3">
                    Not at all! Our online AI content detector tool doesn't
                    require any premium membership from its users. Moreover,
                    they don't have to install any application or sign up to
                    detect AI in any written content.
                  </div>
                </div>
              </a>
            </div>
            <div
              class="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link nav-pills"
                style="
                  border: 1px solid #eaeaea;
                  padding: 10px 14px;
                  background-color: #f3f8fc;
                  border-radius: 10px;
                "
                [ngClass]="{ active: activeTab === 'q15' }"
                (click)="toggleTab('q15')"
                id="v-pills-2nd-tab"
                aria-controls="q15"
                aria-expanded="false"
                class="mb-0 collapsed"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header ms-3"
                    [class.closed]="activeTab !== 'q15'"
                  >
                    Is this AI Detector Capable of Providing Reliable Results?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q15'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q15'"
                  />
                </div>

                <div
                  aria-labelledby="q15"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q15' }"
                  id="q15"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body carbody ms-3 me-3">
                    Yes! Our AI tool uses modern technology and NLP algorithms
                    to process your uploaded information and provides you with
                    100% reliable results. This tool is capable of detecting
                    content generated by GPT to GPT-3, GPT-3.5, and GPT-4.
                  </div>
                </div>
              </a>
            </div>
            <div
              class="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link nav-pills"
                style="
                  border: 1px solid #eaeaea;
                  padding: 10px 14px;
                  background-color: #f3f8fc;
                  border-radius: 10px;
                "
                [ngClass]="{ active: activeTab === 'q6' }"
                (click)="toggleTab('q6')"
                id="v-pills-4th-tab"
                aria-controls="q6"
                aria-expanded="false"
                class="mb-0 collapsed"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header ms-3"
                    [class.closed]="activeTab !== 'q6'"
                  >
                    Can This AI Tool Detect Text Created by GPT-4?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q6'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q6'"
                  />
                </div>

                <div
                  aria-labelledby="q6"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q6' }"
                  id="q6"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body carbody ms-3 me-3">
                    Yes! Our online AI content checker detects GPT-4 generated
                    text. You can also use this free tool to detect content
                    generated by any other AI tool in a few seconds.
                  </div>
                </div>
              </a>
            </div>
            <div
              class="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link nav-pills"
                style="
                  border: 1px solid #eaeaea;
                  padding: 10px 14px;
                  background-color: #f3f8fc;
                  border-radius: 10px;
                "
                [ngClass]="{ active: activeTab === 'q7' }"
                (click)="toggleTab('q7')"
                id="v-pills-5th-tab"
                aria-controls="q7"
                aria-expanded="false"
                class="mb-0 collapsed"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header ms-3"
                    [class.closed]="activeTab !== 'q7'"
                  >
                    How Does an AI Content Detector Identify AI Content?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q7'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q7'"
                  />
                </div>

                <div
                  aria-labelledby="q7"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q7' }"
                  id="q7"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body carbody ms-3 me-3">
                    Our online AI detector mainly emphasizes three major
                    aspects: Predictability, Probability, and Pattern. Once a
                    user enters the text, the tool initiates the AI check on the
                    basis of the aforementioned attributes and identifies if it
                    detects any AI-written content.
                  </div>
                </div>
              </a>
            </div>
            <div
              class="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link nav-pills"
                style="
                  border: 1px solid #eaeaea;
                  padding: 10px 14px;
                  background-color: #f3f8fc;
                  border-radius: 10px;
                "
                [ngClass]="{ active: activeTab === 'q16' }"
                (click)="toggleTab('q16')"
                id="v-pills-6th-tab"
                aria-controls="q16"
                aria-expanded="false"
                class="mb-0 collapsed"
              >
               

                <div class="nav-linkFAQ">
                  <h3
                    class="card-header ms-3"
                    [class.closed]="activeTab !== 'q16'"
                  >
                    Can I Use This AI Detector on a Smartphone?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q16'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q16'"
                  />
                </div>

                <div
                  aria-labelledby="q16"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q16' }"
                  id="q16"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body carbody ms-3 me-3">
                    Yes! Our online AI content detector supports all devices,
                    including laptops, computers, and smartphones. Moreover,
                    this AI tool works exquisitely on all platforms, giving its
                    users an easy way to detect AI text in any content without
                    observing any obstacles.
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  -->
  <div
    class="modal modal-home centered fade bd-example-modal-lg text-center justify-content-center"
    data-backdrop="static"
    data-keyboard="false"
    tabindex="-1"
    role="dialog"
    aria-labelledby="checkgrammar-btn-plag"
    aria-hidden="true"
  >
    <div class="modal-dialog centered modal-lg">
      <div
        class="modal-content modal-content-home"
        style="height: 640px !important"
      >
        <img
          class="modal-content-ai-img"
          data-dismiss="modal"
          src="../../assets/images/plagiarism checker/cross.svg"
          alt="cross-img"
          style="cursor: pointer"
        />
        <div class="modal-content-home-text">
          <h3
            id="set-target-heading-ai"
            class="justify-content-center"
            style="margin-left: 0px"
          >
            Give Feedback
          </h3>
          <p
            id="set-target-title-ai"
            class="justify-content-center"
            style="margin-left: 0px"
          >
            We value users’ input to make their experience even better. Help
            <br />
            us improve GrammarIn with your valuable feedback.
          </p>
          <div
            class="row set-target-row justify-content-center"
            style="margin-left: 0px"
          >
            <div
              style="display: inherit; cursor: pointer; justify-content: center"
            >
              <div (click)="terriblevalue()" class="ai-terrible">
                <img
                  src="../../assets/images/emoji/emoji/Terrible.svg"
                  class="ai-terrible-img"
                  alt="Terrible-img"
                />
              </div>
              <div (click)="getbad()" class="ai-bad">
                <img
                  src="../../assets/images/emoji/emoji/Bad.svg"
                  alt="Bad-img"
                  class="ai-terrible-img"
                />
              </div>
              <div (click)="gotokay()" class="ai-oky">
                <img
                  src="../../assets/images/emoji/emoji/Okay.svg"
                  alt="Okay-img"
                  class="ai-terrible-img"
                />
              </div>
              <div (click)="gotgood()" class="ai-good">
                <img
                  src="../../assets/images/emoji/emoji/Good.svg"
                  alt="Good-img"
                  class="ai-terrible-img"
                />
              </div>
              <div (click)="amzaing()" class="ai-amazing">
                <img
                  src="../../assets/images/emoji/emoji/Amazing.svg"
                  alt="Amazing-img"
                  class="ai-terrible-img"
                />
              </div>
            </div>
            <div style="display: contents; cursor: pointer">
              <p
                class="ai-terrible-t"
                (click)="terriblevalue()"
                [ngClass]="{ selected: getterrible }"
              >
                Terrible
              </p>
              <p
                class="ai-bad-t"
                (click)="getbad()"
                [ngClass]="{ selected: badvalue }"
              >
                Bad
              </p>
              <p
                class="ai-okay-t"
                (click)="gotokay()"
                [ngClass]="{ selected: okayvalue }"
              >
                Okay
              </p>
              <p
                class="ai-good-t"
                (click)="gotgood()"
                [ngClass]="{ selected: goodvalue }"
              >
                Good
              </p>
              <p
                class="ai-amazing-t"
                (click)="amzaing()"
                [ngClass]="{ selected: amzaingvalue }"
              >
                Amazing
              </p>
            </div>
          </div>
          <div class="container justify-content-center text-center">
            <input
              required
              class="ai-feedback-comment justify-content-center"
              [(ngModel)]="feedbackValue"
              contenteditable="true"
              placeholder="Add Comments..."
              name="feedback"
              id="feedid"
              style="outline: none; padding-bottom: 100px"
              type="text"
              autocomplete="off"
            />
            <br />
            <div
              class="container justify-content-center mt-2 ai-user-exper-h"
              style="
                justify-content: center;
                align-items: center;
                display: flex;
              "
            >
              <p
                class="text-left px-3 mt-10-ai"
                id="esubTextExp"
                [ngStyle]="{ color: color }"
                *ngIf="showmsg"
                style="margin-top: -5px"
              >
                <i
                  class="fas fa-check-circle"
                  aria-hidden="true"
                  style="margin-right: 3px"
                ></i
                >{{ esubTextExp }}
              </p>
              <div
                *ngIf="showfeedbackloader"
                class="progress-feedback"
                style="
                  align-items: center;
                  justify-content: center;
                  margin-left: 0px;
                "
              ></div>
            </div>
            <button
              id="set-target-btn-ai"
              class="btn default justify-content-center"
              (click)="sendfeedback()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-feedback></app-feedback>
  <a
    (click)="scrollToTop()"
    *ngIf="shouldShowButton"
    id="scroll-to-top"
    data-tooltip="Go to top"
  >
    <app-icons-free-tools name="goToTopIcon" />
  </a>

  <app-premium-modal-startup></app-premium-modal-startup>
  <app-footer></app-footer>
</div>
